<div>
  <mapfre-footer
    [ngClass]="{
      'mapfre-hide': (patrimonialService.origin$ | async) !== 'METS'
    }"
  ></mapfre-footer>
  <div
    class="patrimonials-footer"
    [ngClass]="{
      'mapfre-hide': (patrimonialService.origin$ | async) === 'METS'
    }"
  >
    <ion-buttons mode="md" slot="start">
      <div>
        <div class="mapfre-fs-xxs medium custom-margin-right-xs ws-nw">
          {{ 'PWA_PATRIMONIALS.FOOTER.MAPFRE_TITLE' | translate }}
        </div>
      </div>
      <div class="medium-light">|</div>
      <div>
        <div
          class="mapfre-fs-xxs medium cp custom-margin-left-xs custom-margin-right-xs ws-nw"
          (click)="onOpenRGPDUEWeb()"
        >
          {{ 'PWA_PATRIMONIALS.FOOTER.PRIVACY' | translate | capitalizeString }}
        </div>
      </div>
      <div class="medium-light">|</div>
      <div>
        <div
          class="mapfre-fs-xxs medium cp custom-margin-left-xs custom-margin-right-xs ws-nw"
          (click)="onOpenMapfreWeb()"
        >
          {{ 'PWA_PATRIMONIALS.FOOTER.INSURANCE' | translate }}
        </div>
      </div>
      <div class="medium-light">|</div>
      <div>
        <div
          class="mapfre-fs-xxs medium cp custom-margin-left-xs custom-margin-right-xs ws-nw"
          onclick="OneTrust.ToggleInfoDisplay()"
        >
          {{ 'PWA_PATRIMONIALS.FOOTER.INSURANCE' | translate }}
        </div>
      </div>
    </ion-buttons>
  </div>
</div>
